import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material";
import { ExcelService } from "../../../services/index";
import { SalesOrderService } from "../../../services/salesOrder.service";

@Component({
  selector: "core-pending-order",
  templateUrl: "corePendingOrder.html",
})
export class corePendingOrder implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();
  isLoadMask: Promise<any>;
  loadingIndicator: boolean;
  gridOptions: any;
  IsWait: boolean = false;
  exceldata: any;
  curDate = new Date();
  coreGangType = ["PLAIN","NEW"];
  coreViewType = ["ORDER","NON ORDER"];
  coreViewDesign = ["ALL COLOR","SINGLE COLOR"];

  filter = {
    from_date: "",
    to_date: "",
    core_gang_type: "PLAIN",
    core_view_type: "ORDER",
    core_view_design: "",
    coreGangDesign: "",
    shade: "",
    groupby: "design",
  };
  columns = [];
  excelColumns = [];
  toggleCol = [];
  coreGangDesignList = [];

  finyearList: any;
  pendingOrderStock: any;
  stockOrder: any;
  totalOrderPend: any;

  constructor(
    private salesOrderServ: SalesOrderService,
    private spin: MatProgressSpinnerModule,
    private excelService: ExcelService,

    public datePipe: DatePipe
  ) {
    let from_date =
        this.curDate.getFullYear() +
        "-" +
        this.curDate.getMonth() +
        "-" +
        this.curDate.getDate(),
      to_date =
        this.curDate.getFullYear() +
        "-" +
        (this.curDate.getMonth() + 1) +
        "-" +
        this.curDate.getDate();

    this.filter.from_date = this.datePipe.transform(from_date, "yyyy-MM-dd");
    this.filter.to_date = this.datePipe.transform(to_date, "yyyy-MM-dd");
    this.loadingIndicator = true;
  }

  ngOnInit(): void {
    this.getColumns();
    // this.getCoreGangPendingOrder();
    this.getCoreGangDesignList();

    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };

    this.toggleCol = Object.assign({}, this.columns);
  }

  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback();
  }

  pageCallback() {
    this.getCoreGangPendingOrder();
  }

  onPrevClick() {
    if (this.filter.groupby == "designColor") {
      this.filter.groupby = "design";
      this.filter.coreGangDesign = "";
      this.filter.core_view_design ="";
    }
    // if (this.filter.groupby == "designColorOrder") {
    //   this.filter.groupby = "designColor";
    //   this.filter.coreGangDesign = this.pendingOrderStock[0].core_designno;
    //   this.filter.shade = "";
    // }

    this.getCoreGangPendingOrder();
  }

  getCoreGangDesignList() {
    let params = {
      coreGangType: this.filter.core_gang_type,
      coreViewType: this.filter.core_view_type,
    };
    this.salesOrderServ.getCoreGangDesignList(params).then((res: any) => {
      this.coreGangDesignList = res;
    });
  }

  onSelectCoreGang(designtype) {
    this.filter.core_gang_type = designtype;
    this.getCoreGangDesignList();
  }
  onSelectCoreView(viewType) {
    this.filter.core_view_type = viewType;
    // this.getCoreGangDesignList();
  }
  onSelectDesignView(viewDesign) {
    this.filter.core_view_design = viewDesign;
    // this.getCoreGangDesignList();
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }
  getCoreGangPendingOrder() {
    this.IsWait = true;

    if (this.filter.coreGangDesign == "") {
      this.filter.groupby = "design";
    }
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    let params = {
      filter: JSON.stringify(this.filter),
    };

    let that = this;

    that.gridOptions = {
      loading: true,
      columns: [],
    };
    that.salesOrderServ.getCoreGangPendingOrder(params).then((res: any) => {
      this.IsWait = false;
      that.pendingOrderStock = res.pendOrdStock;
      if(this.filter.core_view_type == "ORDER" ){
      that.pendingOrderStock = that.pendingOrderStock.filter((stkArr) => stkArr.tot > 0);
      }
      if (that.filter.groupby == "designColor") {
        that.pendingOrderStock.forEach((e,ind) => {
          if(ind != that.pendingOrderStock.length - 1){
              if ((that.pendingOrderStock[ind].design_id == that.pendingOrderStock[ind + 1].design_id)){
            that.pendingOrderStock[ind].stot = 0;
          } 
        }
          
        });
  
      }
      that.setColumns(that.filter.groupby);

      if (that.filter.groupby == "designColor") {
        that.pendingOrderStock = that.pendingOrderStock.sort(
          (a, b) => parseFloat(a.shade) - parseFloat(b.shade)
        );
      }
      // if (that.filter.groupby == "designColorOrder") {
      //   that.stockOrder = res.stockArr;
      //   that.totalOrderPend = res.totalOrderPend;
      // }

      that.exceldata = that.getData(that.excelColumns, that.pendingOrderStock);
    });
  }
  setColumns(groupby) {
    if (groupby == "design") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "Design No",
          prop: "core_designno",
        },
        {
          name: "FTOT",
          prop: "ftot",
        },
        {
          name: "HTOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    } else if (groupby == "designColor") {
      this.excelColumns = [
        {
          name: "sno",
          prop: "sno",
        },
        {
          name: "So.No",
          prop: "so_no",
        },
        {
          name: "So.Date",
          prop: "so_date",
        },
        {
          name: "Party Name",
          prop: "party_name",
        },
        {
          name: "Design No",
          prop: "core_designno",
        },
        {
          name: "Shade",
          prop: "shade",
        },
        {
          name: "F36",
          prop: "f36",
        },
        {
          name: "F38",
          prop: "f38",
        },
        {
          name: "F40",
          prop: "f40",
        },
        {
          name: "F42",
          prop: "f42",
        },
        {
          name: "F44",
          prop: "f44",
        },
        {
          name: "F46",
          prop: "f46",
        },
        {
          name: "H36",
          prop: "h36",
        },
        {
          name: "H38",
          prop: "h38",
        },
        {
          name: "H40",
          prop: "h40",
        },
        {
          name: "H42",
          prop: "h42",
        },
        {
          name: "H44",
          prop: "h44",
        },
        {
          name: "H46",
          prop: "h46",
        },
        {
          name: "F.TOT",
          prop: "ftot",
        },
        {
          name: "H.TOT",
          prop: "htot",
        },
        {
          name: "TOT",
          prop: "tot",
        },
      ];
    } 
    // else if (groupby == "designColorOrder") {
    //   this.excelColumns = [
    //     {
    //       name: "sno",
    //       prop: "sno",
    //     },
    //     {
    //       name: "So.No",
    //       prop: "so_no",
    //     },
    //     {
    //       name: "So.Date",
    //       prop: "so_date",
    //     },
    //     {
    //       name: "Party Name",
    //       prop: "party_name",
    //     },
    //     {
    //       name: "F36",
    //       prop: "f36",
    //     },
    //     {
    //       name: "F38",
    //       prop: "f38",
    //     },
    //     {
    //       name: "F40",
    //       prop: "f40",
    //     },
    //     {
    //       name: "F42",
    //       prop: "f42",
    //     },
    //     {
    //       name: "F44",
    //       prop: "f44",
    //     },
    //     {
    //       name: "F46",
    //       prop: "f46",
    //     },
    //     {
    //       name: "H36",
    //       prop: "h36",
    //     },
    //     {
    //       name: "H38",
    //       prop: "h38",
    //     },
    //     {
    //       name: "H40",
    //       prop: "h40",
    //     },
    //     {
    //       name: "H42",
    //       prop: "h42",
    //     },
    //     {
    //       name: "H44",
    //       prop: "h44",
    //     },
    //     {
    //       name: "H46",
    //       prop: "h46",
    //     },
    //     {
    //       name: "F.TOT",
    //       prop: "ftot",
    //     },
    //     {
    //       name: "H.TOT",
    //       prop: "htot",
    //     },
    //     {
    //       name: "TOT",
    //       prop: "tot",
    //     },
    //   ];
    // }
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
  onDesignClick(stock) {
    if (this.filter.groupby == "design") {
      this.filter.groupby = "designColor";
      this.filter.coreGangDesign = stock.core_designno;
    } 
    else if (this.filter.groupby == "designColor") {
      // this.filter.groupby = "designColorOrder";
      this.filter.coreGangDesign = stock.core_designno;
      this.filter.shade = stock.shade;
    }

    this.getCoreGangPendingOrder();
  }

  ngOnDestroy() {
    this.salesOrderServ;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/corePendingOrder/corePendingOrder.ts